import React, { useState, ChangeEvent } from "react";
import {
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
  Link,
  Divider,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import theme from "../theme";
import BasicModal from "../components/ui/BasicModal";
import Loader from "../components/ui/Loader";
import useFetchLogin from "../Hooks/login/useFetchLogin";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import backgroundImageToLogin from "../assets/loginBG.png";
import { Box, fontFamily } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
const Login: React.FC = () => {
  const [forgotPassword, setForgotPassword] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const adminRole = "admin";
  const containerStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
  };
  const paperStyle: React.CSSProperties = {
    height: "75%",
    width: "75%",
    borderRadius: "16px",
    overflow: "hidden",
  };
  const logoStyle: React.CSSProperties = {
    padding: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 400,
    height: "500px",
    flexDirection: "column",
    marginRight: "9.375rem",
  };
  const loginStyle: React.CSSProperties = {
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "none",
    color: "#1A3263",
    textAlign: "center",
  };
  const navigate = useNavigate();
  const { handleLogin, handleResetPasswordClick, error, success, loading } =
    useFetchLogin(email, password, adminRole);

  const handleForgotPasswordClick = () => {
    setForgotPassword(true);
  };

  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    const updatedEmail = event.target.value;
    setEmail(updatedEmail);
  };

  const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    const updatedPassword = event.target.value;
    setPassword(updatedPassword);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const handleNavigateToLogin = () => {
    navigate("/login");
    setForgotPassword(false);
  };
  return (
    <Grid
      display={"flex"}
      height={"100vh"}
      justifyContent={"space-around"}
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "space-around",
        opacity: 1,
        backgroundImage: `url(${backgroundImageToLogin})`,
        backgroundSize: "cover",
      }}
    >
      <Grid
        width={"40%"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <img
          src={require("../assets/suntecLogo.png")}
          alt="Logo"
          style={{ maxWidth: "60%", maxHeight: "60%" }}
        />
      </Grid>
      <Grid
        width={"40%"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Paper elevation={5} style={paperStyle}>
          <Grid
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            height={"100%"}
            width={"100%"}
            py={4}
            sx={{ background: theme.color?.background }}
          >
            <Grid
              height={"100%"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={forgotPassword ? "none" : "center"}
            >
              {forgotPassword && (
                <Grid sx={{ mb: forgotPassword ? 8 : 0, ml: 1 }}>
                  <Button onClick={handleNavigateToLogin}>
                    <ArrowBackIcon
                      sx={{ color: theme.color?.newFilterGrey }}
                    ></ArrowBackIcon>
                  </Button>
                </Grid>
              )}
              <Grid>
                <Grid
                  style={{
                    ...loginStyle,
                  }}
                >
                  <Grid display={"flex"} direction={"column"}>
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: "32px",
                        fontWeight: theme.font?.fontWeight.thick,
                        textAlign: "left",
                        marginLeft: 8,
                        color: "#000000",
                      }}
                    >
                      {forgotPassword ? "Forgot Password" : "Welcome"}
                    </Typography>
                    <Typography
                      display={"flex"}
                      sx={{
                        px: 8,
                        fontFamily: theme.font?.fontFamily.primary,
                        fontWeight: theme.font?.fontWeight.slightThick,
                        fontSize: theme.font?.fontSize.tableHeader,
                        color: theme.color?.newFilterGrey,
                        marginTop: forgotPassword ? 2 : 0,
                        marginBottom: 4,
                        textAlign: "left",
                      }}
                    >
                      {forgotPassword
                        ? "Please enter your registered email ID below to reset your password."
                        : null}
                    </Typography>
                  </Grid>
                </Grid>

                {forgotPassword ? (
                  <>
                    <Grid style={loginStyle} px={8}>
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.tableHeader,
                          mb: "6px",
                        }}
                      >
                        Username
                      </Typography>
                      <TextField
                        id="email"
                        variant="outlined"
                        size="small"
                        fullWidth
                        required
                        value={email}
                        onChange={handleEmailChange}
                      />
                      {error && (
                        <Typography
                          textAlign={"left"}
                          sx={{
                            fontFamily: theme.font?.fontFamily.primary,
                            fontSize: theme.font?.fontSize.tableBody,
                            mt: 0.5,
                          }}
                          color={theme.color?.error}
                          align="center"
                          gutterBottom
                        >
                          {error}
                        </Typography>
                      )}
                      {success && (
                        <Typography
                          textAlign={"left"}
                          sx={{
                            fontFamily: theme.font?.fontFamily.primary,
                            fontSize: theme.font?.fontSize.tableBody,
                            mt: 0.5,
                          }}
                          color={theme.color?.success}
                          align="center"
                          gutterBottom
                        >
                          OTP sent to the email
                        </Typography>
                      )}
                    </Grid>
                    <Grid px={8}>
                      <Button
                        type="button"
                        size="medium"
                        variant="contained"
                        sx={{
                          backgroundColor: theme.color?.secondary,
                          marginTop: 3,
                          textTransform: "capitalize",
                          boxShadow: "none",
                        }}
                        fullWidth
                        onClick={handleResetPasswordClick}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12}>
                      {error && (
                        <Typography color="red" align="center" gutterBottom>
                          {error}
                        </Typography>
                      )}
                      {success && (
                        <Typography color="green" align="center" gutterBottom>
                          Logged in
                        </Typography>
                      )}
                    </Grid>
                    <Grid style={loginStyle} px={8}>
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.tableHeader,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          mb: "6px",
                        }}
                      >
                        Username
                      </Typography>
                      <TextField
                        id="email"
                        variant="outlined"
                        fullWidth
                        size="small"
                        required
                        style={{ marginBottom: "16px" }}
                        value={email}
                        onChange={handleEmailChange}
                      />
                      <Typography
                        sx={{
                          textAlign: "left",
                          fontFamily: theme.font?.fontFamily.primary,
                          fontSize: theme.font?.fontSize.tableHeader,
                          fontWeight: theme.font?.fontWeight.slightThick,
                          mb: "6px",
                        }}
                      >
                        Password
                      </Typography>
                      <OutlinedInput
                        id="password"
                        type={showPassword ? "text" : "password"}
                        fullWidth
                        size="small"
                        required
                        style={{ marginBottom: "4px" }}
                        value={password}
                        onChange={handlePasswordChange}
                        onKeyDown={handleKeyDown}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleClickShowPassword}
                              aria-label="toggle password visibility"
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      <Typography align="right">
                        <Link
                          href="#"
                          underline="none"
                          onClick={handleForgotPasswordClick}
                          sx={{
                            color: theme.color?.secondary,
                            fontFamily: theme.font?.fontFamily.primary,
                            fontWeight: theme.font?.fontWeight.thick,
                            fontSize: theme.font?.fontSize.tableHeader,
                          }}
                        >
                          Forgot Password?
                        </Link>
                      </Typography>
                      <br />
                    </Grid>
                    <Grid px={8}>
                      <Button
                        type="submit"
                        size="medium"
                        variant="contained"
                        fullWidth
                        onClick={handleLogin}
                        sx={{
                          backgroundColor: theme.color?.secondary,
                          textTransform: "capitalize",
                          boxShadow: "none",
                        }}
                      >
                        Login
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        {loading && <BasicModal content={<Loader />} />}
      </Grid>
    </Grid>
  );
};

export default Login;
